import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import {environment} from '../../environments/environment';




@Injectable({
  providedIn: 'root'
})
export class DoctorService {

  constructor(private http: HttpClient) { }

  private baseUrl: string = environment.apiUrl;

  private static handleError(error: HttpErrorResponse) {
    console.log(error);

    // return an observable with a user friendly message
    return throwError('Error! something went wrong.');
  }

  addDoctor(doctorPayload) {

    // var reqHeaders = new HttpHeaders({'Content-Type':undefined});
    return this.http.post<any>(`${this.baseUrl}/doctor/add_doc`, doctorPayload)
      .pipe(map(user => {
        return user;
      }));

  }

  updateDoctor(data) {
      // var reqHeaders = new HttpHeaders({'Content-Type':undefined});
      return this.http.post<any>(`${this.baseUrl}/doctor/editdoctor`, data)
        .pipe(map(user => {
          return user;
        }));

  }

  updateDoctorData(data: FormData) {
    // var reqHeaders = new HttpHeaders({'Content-Type':undefined});
    return this.http.post<any>(`${this.baseUrl}/doctor/editdoctordatafromadmin`, data)
      .pipe(map(user => {
        return user;
      }));
  }

  setSpecialDoctors(data) {
    return this.http.post<any>(`${this.baseUrl}/doctor/set-special-doctor`, data)
      .pipe(map(user => {
        return user;
      }));

  }


  addGiftCodeRemaining(Payload) {
    return this.http.post<any>(`${this.baseUrl}/prices/addGiftCodeRemaining`, Payload)
      .pipe(map(res => {
          return res;
        }),
        catchError(DoctorService.handleError));
  }


  processPaymentRefund(data): Observable<any> {
    return this.http.post(`${this.baseUrl}/appointments/processpaymentrefund`,data)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(DoctorService.handleError));
  }
  getUserAppointment(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/appointments/getpatientappointments`,payload).pipe(
      map((res) => {
        return res;
      }),
      catchError(DoctorService.handleError));
  }

  getPromoCodeByCode(Payload) {
    return this.http.post<any>(`${this.baseUrl}/prices/getPromoCodeByCode`, Payload)
      .pipe(map(res => {
          return res;
        }),
        catchError(DoctorService.handleError));
  }

  updateFullTimePartTime(data) {
    return this.http.post<any>(`${this.baseUrl}/doctor/updateFullTimePartTime`, data)
      .pipe(map(user => {
        return user;
      }));

  }

  getAllDoctors(): Observable<any> {
    return this.http.get(`${this.baseUrl}/doctor/getdoclist`).pipe(
      map((res) => {
        return res;
      }),
      catchError(DoctorService.handleError));
  }
  getDoctorsByStatus(data): Observable<any> {
    return this.http.post(`${this.baseUrl}/doctor/getDoctorsListByStatus`,data).pipe(
      map((res) => {
        return res;
      }),
      catchError(DoctorService.handleError));
  }


  getAllDoctorsList(postData): Observable<any> {
    return this.http.post(`${this.baseUrl}/doctor/doctorslistfilter?pageNo=1&size=500`,postData).pipe(
      map((res) => {
        return res;
      }),
      catchError(DoctorService.handleError));
  }

  getDoctorById(docid): Observable<any> {
    return this.http.get(`${this.baseUrl}/doctor/getdocbyid/${docid}`).pipe(
      map((res) => {
        return res;
      }),
      catchError(DoctorService.handleError));
  }

  getDoctorAppointment(doctorPayload): Observable<any> {
    return this.http.post(`${this.baseUrl}/appointments/getdoctorappointments`, doctorPayload)
      .pipe(
      map((res) => {
        return res;
      }),
      catchError(DoctorService.handleError));
  }

  getAppointmentFeedback(doctorPayload): Observable<any> {
    return this.http.post(`${this.baseUrl}/appointments/getAppointmentFeedback`, doctorPayload)
      .pipe(
      map((res) => {
        return res;
      }),
      catchError(DoctorService.handleError));
  }

  updateAppointmentFeedback(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/appointments/update-feedback-status`, payload)
      .pipe(
      map((res) => {
        return res;
      }),
      catchError(DoctorService.handleError));
  }

  getAppointmentOfSinglePatient(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/appointments/getdoctorappointmentssinglepatient`, payload)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(DoctorService.handleError));
  }

  updateStatus(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/appointments/changestatus`, payload)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(DoctorService.handleError));
  }

  deleteUser(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/user/deleteUser`, payload)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(DoctorService.handleError));
  }

  getDoctorAvavilityByDate(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/doctor/get-doctor-availibility`,payload).pipe(
      map((res) => {
        return res;
      }),
      catchError(DoctorService.handleError));
  }

  getDoctorAvalibilityByDateNew(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/doctor/getDoctorAvalibilityByDateNew`,payload).pipe(
      map((res) => {
        return res;
      }),
      catchError(DoctorService.handleError));
  }

  getAppointmentById(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/appointments/getappointmentbyid`,payload).pipe(
      map((res) => {
        return res;
      }),
      catchError(DoctorService.handleError));
  }

  getAllAppointment(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/appointments/getallappointments`,payload).pipe(
      map((res) => {
        return res;
      }),
      catchError(DoctorService.handleError));
  }

  listAllAppointment(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/appointments/listallappointments`,payload).pipe(
      map((res) => {
        return res;
      }),
      catchError(DoctorService.handleError));
  }

  listAllAppointmentPagination(page,size,payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/appointments/listallappointments?offset=${page}&limit=${size}`,payload).pipe(
      map((res) => {
        return res;
      }),
      catchError(DoctorService.handleError));
  }

  listAllEapAppointments(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/appointments/listAllEapAppointments`,payload).pipe(
      map((res) => {
        return res;
      }),
      catchError(DoctorService.handleError));
  }

  checkRemainingSession(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/appointments/checkRemainingSession`, payload)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(DoctorService.handleError));
  }

  addUsedCode(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/appointments/addusedcode`, payload)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(DoctorService.handleError));
  }



  rescheduleAppointment(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/appointments/rescheduleappointment`,payload).pipe(
      map((res) => {
        return res;
      }),
      catchError(DoctorService.handleError));
  }

  sendAppointmentCompletionEmail(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/appointments/send-appointment-complete-email`,payload).pipe(
      map((res) => {
        return res;
      }),
      catchError(DoctorService.handleError));
  }

  getWishList(data,page,size) {
    return this.http.post<any>(`${this.baseUrl}/doctor/getWishList?pageNo=${page}&size=${size}`, data)
      .pipe(map(user => {
        return user;
      }));

  }

  transferPatient(data): Observable<any> {
    return this.http.post(`${this.baseUrl}/doctor/transferTherapistFromAdmin`,data).pipe(
      map((res) => {
        return res;
      }),
      catchError(DoctorService.handleError));
  }

  removeTransfer(data): Observable<any> {
    return this.http.post(`${this.baseUrl}/doctor/removeTransfer`,data).pipe(
      map((res) => {
        return res;
      }),
      catchError(DoctorService.handleError));
  }

  getPatientDoctorsList(data): Observable<any> {
    return this.http.post(`${this.baseUrl}/appointments/getPatientDoctorsList`,data).pipe(
      map((res) => {
        return res;
      }),
      catchError(DoctorService.handleError));
  }

  getTransferList(data): Observable<any> {
    return this.http.post(`${this.baseUrl}/doctor/getTransferList`,data).pipe(
      map((res) => {
        return res;
      }),
      catchError(DoctorService.handleError));
  }

  checkAppointmentBooked(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/appointments/checkAppointmentBooked`,payload).pipe(
      map((res) => {
        return res;
      }),
      catchError(DoctorService.handleError));
  }

  cancelAppointment(Payload) {
    return this.http.post<any>(`${this.baseUrl}/prices/cancelAppointment`, Payload)
      .pipe(map(res => {
          return res;
        }),
        catchError(DoctorService.handleError));
  }

  getMeetingById(docid): Observable<any> {
    return this.http.get(`${this.baseUrl}/doctor/getMeetingDetails/${docid}`).pipe(
      map((res) => {
        return res;
      }),
      catchError(DoctorService.handleError));
  }

  updateMeetingDoctors(Payload) {
    return this.http.post<any>(`${this.baseUrl}/doctor/updateMeetingDoctors`, Payload)
      .pipe(map(res => {
          return res;
        }),
        catchError(DoctorService.handleError));
  }

  getSpecialisation() {
    return this.http.get<any>(`${this.baseUrl}/doctor/getSpecialisation`)
      .pipe(map(res => {
          return res;
        }),
        catchError(DoctorService.handleError));
  }

  getLanguages() {
    return this.http.get<any>(`${this.baseUrl}/doctor/getLanguages`)
      .pipe(map(res => {
          return res;
        }),
        catchError(DoctorService.handleError));
  }

  getSpeciality() {
    return this.http.get<any>(`${this.baseUrl}/doctor/getSpeciality`)
      .pipe(map(res => {
          return res;
        }),
        catchError(DoctorService.handleError));
  }

  getDegree() {
    return this.http.get<any>(`${this.baseUrl}/doctor/getDegree`)
      .pipe(map(res => {
          return res;
        }),
        catchError(DoctorService.handleError));
  }
}
